import { CognitiveDomain, Feature } from "types/api";
import { Option } from "types/utils";
import { CognitiveDomainWithFeature } from "./types";

export const featureOptions: Option<Feature>[] = [
  { value: Feature.HealthyBrainActivity, label: Feature.HealthyBrainActivity },
  { value: Feature.Instructions, label: Feature.Instructions },
  { value: Feature.Lifestyle, label: Feature.Lifestyle },
  {
    value: Feature.CompensatoryStrategies,
    label: Feature.CompensatoryStrategies,
  },
];

export const cognitiveDomainsOptions: CognitiveDomainWithFeature[] = [
  {
    feature: Feature.HealthyBrainActivity,
    value: CognitiveDomain.ThoughtOrganization,
    label: "Thought Organization",
  },
  {
    feature: Feature.HealthyBrainActivity,
    value: CognitiveDomain.ReasoningLogic,
    label: "Reasoning and Logic",
  },
  {
    feature: Feature.HealthyBrainActivity,
    value: CognitiveDomain.ProblemSolving,
    label: "Problem Solving",
  },
  {
    feature: Feature.HealthyBrainActivity,
    value: CognitiveDomain.PlanningAndOrganization,
    label: "Planning and Organization",
  },
  {
    feature: Feature.HealthyBrainActivity,
    value: CognitiveDomain.ShortTermMemory,
    label: "Short Term Memory",
  },
  {
    feature: Feature.HealthyBrainActivity,
    value: CognitiveDomain.LongTermMemory,
    label: "Long Term Memory",
  },
  {
    feature: Feature.HealthyBrainActivity,
    value: CognitiveDomain.AuditoryProcessing,
    label: "Auditory Processing",
  },
  {
    feature: Feature.HealthyBrainActivity,
    value: CognitiveDomain.ProceduralMemory,
    label: "Procedural Memory",
  },
  {
    feature: Feature.HealthyBrainActivity,
    value: CognitiveDomain.AttentionAndConcentration,
    label: "Attention and Concentration",
  },
  {
    feature: Feature.HealthyBrainActivity,
    value: CognitiveDomain.ExpressiveLanguage,
    label: "Expressive Language",
  },
  {
    feature: Feature.HealthyBrainActivity,
    value: CognitiveDomain.ReceptiveLanguage,
    label: "Receptive Language",
  },
  {
    feature: Feature.HealthyBrainActivity,
    value: CognitiveDomain.Transition,
    label: "Transition",
  },
  {
    feature: Feature.Instructions,
    value: CognitiveDomain.Intro,
    label: "Intro",
  },
  {
    feature: Feature.Instructions,
    value: CognitiveDomain.Outro,
    label: "Outro",
  },
  {
    feature: Feature.Instructions,
    value: CognitiveDomain.RecordingFeedback,
    label: "Recording Feedback",
  },
  {
    feature: Feature.Instructions,
    value: CognitiveDomain.ClientReflection,
    label: "Client Reflection",
  },
];
